import React from 'react';
import _ from 'underscore';

import { WindowLocationService } from '~commonInfra/services/WindowLocationService';
import { UrlParamKeys } from '~commonInfra/url/UrlParamKeys';
import { Helpers } from '~commonInfra/utils/Helpers';
import { tabcldPostloginNotification } from '~src/tabcldNotifications/TabcldPostloginNotification';

import { useIsMounted } from '../../../bootstrap/hooks';
import { postLoginNotification } from '../../../zeus/PostLoginNotification';

export const ProcessAndRemoveSamlQueryWrapper: React.FunctionComponent<{}> = props => {
  const isMounted = useIsMounted();
  if (!isMounted) {
    const search: any = WindowLocationService.getHashQueryObject();
    if (_.has(search, UrlParamKeys.IsFromSaml)) {
      if (Helpers.BooleanQueryParamRegex.test(search[UrlParamKeys.IsFromSaml])) {
        if (postLoginNotification) {
          postLoginNotification.enableNotifications();
        }
        if (tabcldPostloginNotification) {
          tabcldPostloginNotification.enableNotifications();
        }
      }

      WindowLocationService.deleteQueryParameter(UrlParamKeys.IsFromSaml);
    }
  }

  return <>{props.children}</>;
};
